require('../../modules/es6.object.assign');
module.exports = require('../../modules/$.core').Object.assign;


//////////////////
// WEBPACK FOOTER
// ./~/react-google-recaptcha/~/core-js/library/fn/object/assign.js
// module id = 679
// module chunks = 0